import React, { useCallback, useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

const RECAPTCHA_KEY_V2CB = '6LfVYfYZAAAAAGuftp-YfnJHnCid8chBKB6RNdNF';
const RECAPTCHA_KEY_V2CB_SERVER = '6LfVYfYZAAAAAA1oxUle09EdV0RN3w7vgC6KhwNB';
const RECAPTCHA_URL = 'https://www.google.com/recaptcha/api/siteverify';

const verifyToken = async (humanKey: string) => {
  const response = await fetch(RECAPTCHA_URL, {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    },
    body: `secret=${RECAPTCHA_KEY_V2CB_SERVER}&response=${humanKey}`,
  })
    .then((res) => res.json())
    .catch((err) => {
      throw new Error(`Error in Google Siteverify API. ${err.message}`);
    });

  return response;
};

type Props = {
  withVerifyBtn?: boolean;
  onTokenChanged?: (token: string) => void;
  onTokenVerified?: () => void;
  hide?: boolean;
};

const Form: React.FC<Props> = (props) => {
  const [token, setToken] = useState('');
  const recaptchaRef = React.createRef<ReCAPTCHA>();

  const onChange = useCallback(
    (token: any) => {
      Logger.info(['Captcha value:', token], LogArea.Security);
      setToken(token);
    },
    [setToken]
  );

  useEffect(() => {
    props.onTokenChanged?.(token);
  }, [token]);

  const onSubmit = async () => {
    verifyToken(token).then((res) => {
      Logger.info(['onSubmit value:', token, res], LogArea.Security);
      props.onTokenVerified?.();
    });
  };

  return (
    <div className={"recaptcha_box " + (props.hide ? 'hide' : '')}>
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={RECAPTCHA_KEY_V2CB}
        onChange={onChange}
        //size={props.hide ? 'invisible' : undefined}
      />
      {props.withVerifyBtn ? <button onClick={onSubmit}>Verify</button> : <></>}
    </div>
  );
};

export default Form;
